/**
 * ============================================================
 * WHITE-LABEL BRAND CONFIGURATION
 * ============================================================
 * All brand-specific values are centralized here.
 * To rebrand for a new client, only edit this file.
 * ============================================================
 */

export const brandConfig = {
  // Brand Identity
  brand_name: 'Anapurna Sales',
  brand_tagline: 'Your Gratification Is Our Responsibility',
  brand_logo: '/src/assets/images/anapurna_logo_transparent.png', // Actual logo PNG

  // Hero Section
  hero_headline: 'Premium Wholesale Fashion at Factory Prices',
  hero_subheadline: 'Trusted by 500+ Retailers Across India',
  hero_subtext: 'Low MOQ | Fast Delivery | Pan India Supply',

  // Trust Badges
  trust_stat_orders: '10,000+',
  trust_stat_orders_label: 'Orders Delivered',
  trust_stat_experience: '11+',
  trust_stat_experience_label: 'Years Experience',
  trust_stat_coverage: 'Pan India',
  trust_stat_coverage_label: 'Delivery',
  trust_stat_retailers: '500+',
  trust_stat_retailers_label: 'Trusted Retailers',
  trust_stat_cities: '10+',
  trust_stat_cities_label: 'Cities Served',

  // Contact Information
  contact_person: 'Atul Sarraf',
  phone_number: '9212150288, 9311150288',
  whatsapp_number: '+919212150288', // Primary B2B WhatsApp
  email: 'del@anapurnasales.com',
  business_address: 'X/938, Satsang Marg, New Chand Mohalla, Jheel Chowk, Gandhi Nagar, Delhi-110031',
  gst_number: '24XXXXX0000X1ZX',

  // Business Details
  business_hours: 'Tue–Sun: 9 AM – 7 PM (Monday Closed)',
  established_year: '2019',
  min_order_quantity: '50',
  moq_unit: 'Pieces',

  // Collection Names
  collection_name_1: "Ladies Boutique Collection",
  collection_name_2: "Men's Wholesale Collection",
  collection_name_3: "Kids Bulk Collection",
  collection_name_4: "Saree Collection",
  collection_name_5: "Blanket Collection",
  collection_name_6: "Ethnic Collection",

  // CTA Labels
  cta_primary: 'Start Bulk Enquiry',
  cta_secondary: 'Chat on WhatsApp',
  cta_catalog: 'Download Catalog',

  // Social MediaLinks
  instagram_url: 'https://www.instagram.com/anapurnasales1/',
  facebook_url: 'https://facebook.com/anupamsales',
  whatsapp_chat_url: 'https://wa.me/919212150288',
  youtube_url: 'https://www.youtube.com/@AnapurnaSales',

  // Catalog
  catalog_download_url: '/catalog.pdf',

  // SEO
  seo_title: 'Anapurna Sales – Premium Wholesale Fashion | B2B Clothing Supplier India',
  seo_description:
    'Anapurna Sales is a leading B2B wholesale fashion supplier in India. Bulk orders, low MOQ, factory-direct pricing across all categories. Trusted by 500+ retailers.',

  // About Us Page
  about_us: {
    story_image: "Local import used in AboutUsPage.jsx",
    story_heading: "Our Journey: From Small Beginnings to a Formidable Entity",
    story_paragraphs: [
      "Anapurna Sales emerged as a humble, small-scale enterprise, driven by a passion for quality. Through unwavering dedication, we have transformed into a formidable entity in the fashion world. Founded on <strong>September 9, 2015</strong>, our growth has been fueled by a commitment to excellence and the trust of our valued partners.",
      "For over <strong>11 years</strong>, our company has been recognized for delivering exceptional service and ensuring high levels of customer satisfaction. We take pride in being a <strong>bridge</strong> between quality manufacturing and the end consumer."
    ],
    founder_quote: "Under his leadership, the company has built excellent relationships with buyers and suppliers across numerous cities. Our operations are defined by <strong>transparency and clarity</strong>, ensuring that every stakeholder feels valued and respected.",
    founder_name: "Mr. Atul Sarraf",
    founder_title: "Founder & Managing Director",
    why_choose_heading: "WHY CHOOSE ANAPURNA SALES?",
    why_choose_cards: [
      {
        icon: "Eye",
        title: "Transparency",
        desc: "Our operations are built on clarity. We believe in honest business dealings that foster long-term growth.",
      },
      {
        icon: "Star",
        title: "11+ Years Experience",
        desc: "A decade-plus of garment industry expertise means we understand quality and market trends better than anyone.",
      },
      {
        icon: "Users",
        title: "Customer Satisfaction",
        desc: "Our primary goal is the happiness of our buyers. We provide exceptional service from order to delivery.",
      }
    ]
  }
};

export default brandConfig;
